var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGauge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M18 138v-17.175C18 77.7 52.65 42.15 95.7 42a77.998 77.998 0 0 1 78.3 78v18a6.002 6.002 0 0 1-6 6H24a6 6 0 0 1-6-6Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M18 138v-17.175C18 77.7 52.65 42.15 95.7 42a77.998 77.998 0 0 1 78.3 78v18a6.002 6.002 0 0 1-6 6H24a6 6 0 0 1-6-6Zm78-96v24M20.625 99.825l23.25 6.225m127.5-6.225-23.25 6.225M77.55 144l51.3-66.825"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/Gauge.d4605f68fe88493ba541af3528c315c0.svg";
export { ForwardRef as ReactComponent };